import { render, staticRenderFns } from "./FormSeat.vue?vue&type=template&id=47d99e02&"
import script from "./FormSeat.vue?vue&type=script&lang=js&"
export * from "./FormSeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports